// Firm logo mark (monochrome PNGs derived from the supplied logo; see scripts/make_logo_assets.py).
// tone="auto": black in light mode, white in dark mode. tone="white": always white (for dark surfaces).
export const LogoMark = ({ className = "h-9 w-auto", tone = "auto", testId = "brand-logo-mark" }) => {
  if (tone === "white") {
    return <img src="/logo-mark-white.png" alt="Alvin Kumar & Associates" className={className} data-testid={testId} />;
  }
  return (
    <>
      <img src="/logo-mark.png" alt="Alvin Kumar & Associates" className={`${className} dark:hidden`} data-testid={testId} />
      <img src="/logo-mark-white.png" alt="" aria-hidden="true" className={`${className} hidden dark:block`} />
    </>
  );
};
